import React, {Fragment, useContext, useEffect, useState} from 'react';

import {Form, FormGroup} from 'reactstrap';

import {useForm} from "react-hook-form";
import {Btn} from "../../../../../AbstractElements";
import TextInput from "../../../../../CommonElements/Input/TextInput";
import Loader from "../../../../../Layout/Loader";
import axiosConfig from "../../../../../Config/axios";
import AuthorizationContext from "../../../../../_helper/Authorization";
import type {Configuration, ConfigurationFormValues, ConfigurationFormProps, Setting} from "../../Types/SettingTypes";
import type {AuthorizationContextType} from "../../../../../_helper/Authorization/AuthorizationTypes";

const ConfigurationForm: React.FC<ConfigurationFormProps> = ({callBack, configuration, setting}) => {
    const [loaderVisibility, setLoaderVisibility] = useState<boolean>(false);
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const {errorHandler} = authContext || {};

    const {
        register, handleSubmit, setError, clearErrors, formState: {errors}, setValue, watch
    } = useForm<ConfigurationFormValues>();

    useEffect(() => {
        if (configuration) {
            setValue('setting_id', configuration.setting_id);
            setValue('key', configuration.key);
            setValue('name', configuration.name);
            setValue('description', configuration.description);
        }
    }, [configuration, setValue])

    const onSubmit = (data: ConfigurationFormValues) => {
        clearErrors();
        setLoaderVisibility(true);
        configuration ? updateConfiguration(data) : createConfiguration(data);
    }

    const createConfiguration = (data: ConfigurationFormValues) => {
        clearErrors();
        setLoaderVisibility(true);
        if (!setting) return;
        data.setting_id = setting.id;
        axiosConfig
            .post(`/system-core/configuration`, data)
            .then((response: { data: { data: Configuration; }; }) => {
                if (response?.data?.data) {
                    callBack?.(response?.data?.data);
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception, setError);
                setLoaderVisibility(false);
            });
    }

    const updateConfiguration = (data: ConfigurationFormValues) => {
        clearErrors();
        setLoaderVisibility(true);
        if (!configuration) return;
        axiosConfig
            .put(`/system-core/configuration/${configuration.id}`, data)
            .then((response: { data: { data: Configuration; }; }) => {
                if (response?.data?.data) {
                    callBack?.(response?.data?.data);
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception, setError);
                setLoaderVisibility(false);
            });
    }

    useEffect(() => {
        if (watch('name') && setting) {
            setValue('key', (`${setting.key} ${watch('name')}`)?.toLowerCase()
                .replace(/\s+/g, '-'));
        } else {
            setValue('key', '');
        }
    }, [watch('name'), setting, setValue])

    return (<Fragment>
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Loader visibility={loaderVisibility}/>
            <TextInput name={'name'} type={'text'} label={'Name'} register={register}
                       errors={errors} placeholder={'Name'} options={{required: true}}/>
            <TextInput name={'key'} type={'text'} readOnly={true} label={'Key'} register={register}
                       errors={errors} placeholder={'Key'} options={{required: true}}/>
            <TextInput name={'description'} type={'text'} label={'Description'} register={register}
                       errors={errors} placeholder={'Description'} options={{required: true}}/>
            <FormGroup>
                <Btn attrBtn={{
                    className: 'd-block w-100 mt-4',
                    color: 'primary',
                    type: 'submit'
                }}>{configuration ? 'Update' : 'Create'}</Btn>
            </FormGroup>
        </Form>
    </Fragment>);
};

export default ConfigurationForm;
